import React, { Suspense, Fragment, lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import DashboardMain from 'src/layouts/DashboardMain';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthGuard from 'src/components/AuthGuard';
import GuestGuard from 'src/components/GuestGuard';

export const renderRoutes = (routes = []) => (
    <Suspense fallback={<LoadingScreen />}>
        <Switch>
            {routes.map((route, i) => {
                const Guard = route.guard || Fragment;
                const Layout = route.layout || Fragment;
                const Component = route.component;

                return (
                    <Route
                        key={i}
                        path={route.path}
                        exact={route.exact}
                        render={props => (
                            <Guard>
                                <Layout>
                                    {route.routes ? (
                                        renderRoutes(route.routes)
                                    ) : (
                                        <Component {...props} />
                                    )}
                                </Layout>
                            </Guard>
                        )}
                    />
                );
            })}
        </Switch>
    </Suspense>
);

const routes = [
    {
        exact: true,
        path: '/404',
        component: lazy(() => import('src/views/errors/NotFoundView')),
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/login',
        component: lazy(() => import('src/views/auth/LoginView')),
    },
    // {
    //     exact: true,
    //     path: '/login-unprotected',
    //     component: lazy(() => import('src/views/auth/LoginView')),
    // },
    // {
    //     exact: true,
    //     guard: GuestGuard,
    //     path: '/register',
    //     component: lazy(() => import('src/views/auth/RegisterView')),
    // },
    {
        exact: true,
        guard: GuestGuard,
        path: '/forgot-password',
        component: lazy(() => import('src/views/auth/ForgotPasswordView')),
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/reset-password',
        component: lazy(() => import('src/views/auth/ResetPasswordView')),
    },
    // {
    //     exact: true,
    //     path: '/register-unprotected',
    //     component: lazy(() => import('src/views/auth/RegisterView')),
    // },

    {
        exact: true,
        guard: AuthGuard,
        path: '/invoices/:clientId/pdf',
        component: lazy(() => import('src/views/invoice/InvoiceDetailsView')),
    },

    {
        exact: true,
        guard: AuthGuard,
        path: '/invoices/:clientId/invoice-cases-pdf',
        component: lazy(() => import('src/views/invoice/InvoiceCasesView')),
    },
    {
        exact: true,
        guard: AuthGuard,
        path: '/invoices/:clientId/case-status-report',
        component: lazy(() => import('src/views/invoice/CaseStatusReportView')),
    },
    {
        exact: true,
        guard: AuthGuard,

        path: '/checks/:id/pdf',
        component: lazy(() => import('src/views/checks/CheckPDFViewer')),
    },

    {
        path: '',
        guard: AuthGuard,
        layout: DashboardMain,
        routes: [
            {
                exact: true,
                path: '/cases',
                component: lazy(() => import('src/views/cases/CaseListView')),
            },
            {
                exact: true,
                path: '/cases/:id/edit',
                component: lazy(() => import('src/views/cases/CaseEditView')),
            },
            {
                exact: true,
                path: '/cases/create',
                component: lazy(() => import('src/views/cases/CaseEditView')),
            },
            {
                exact: true,
                path: '/cases/create/document/:id',
                component: lazy(() => import('src/views/cases/CaseDocumentsView')),
            },
            {
                exact: true,
                path: '/clients',
                component: lazy(() => import('src/views/clients')),
            },
            {
                exact: true,
                path: '/courts',
                component: lazy(() => import('src/views/courts')),
            },
            {
                exact: true,
                path: '/defense-attorneys',
                component: lazy(() => import('src/views/defense-attorneys')),
            },
            {
                exact: true,
                path: '/third-parties',
                component: lazy(() => import('src/views/third-parties')),
            },
            {
                exact: true,
                path: '/checks',
                component: lazy(() => import('src/views/checks')),
            },
            {
                exact: true,
                path: '/invoices',
                component: lazy(() => import('src/views/invoice/InvoiceListView')),
            },
            {
                exact: true,
                path: '/templates',
                component: lazy(() => import('src/views/templates/TemplateListView')),
            },
            {
                exact: true,
                path: '/templates/new',
                component: lazy(() => import('src/views/templates/TemplateEditView')),
            },
            {
                exact: true,
                path: '/templates/:id',
                component: lazy(() => import('src/views/templates/TemplateEditView')),
            },
            {
                exact: true,
                path: '/batch-payment',
                component: lazy(() => import('src/views/batch-payment')),
            },
            // {
            //     exact: true,
            //     path: '/check-reconciliation',
            //     component: lazy(() => import('src/views/check-reconciliation')),
            // },
            {
                exact: true,
                path: '/attach-event-document',
                component: lazy(() => import('src/views/attach-event-document')),
            },
            {
                exact: true,
                path: '/diary-review',
                component: lazy(() => import('src/views/diary-review')),
            },
            {
                exact: true,
                path: '/disbursements',
                component: lazy(() => import('src/views/disbursements')),
            },
            {
                exact: true,
                path: '/remittances',
                component: lazy(() => import('src/views/remittances')),
            },

            {
                exact: true,
                path: '/account',
                component: lazy(() => import('src/views/account/AccountView')),
            },
        ],
    },
    // {
    //     exact: true,
    //     path: '/',
    //     component: () => <Redirect to="/dashboard"/>,
    // },
];

export default routes;
